import { render } from "./specialServiceNumber.vue?vue&type=template&id=fb48551c&scoped=true"
import script from "./specialServiceNumber.vue?vue&type=script&lang=js"
export * from "./specialServiceNumber.vue?vue&type=script&lang=js"

import "./specialServiceNumber.vue?vue&type=style&index=0&id=fb48551c&scoped=true&lang=css"
import "./specialServiceNumber.vue?vue&type=style&index=1&id=fb48551c&lang=css"
script.render = render
script.__scopeId = "data-v-fb48551c"

export default script